<script>
import _ from 'lodash'
import moment from 'moment'
import TimeUtils from '@/utils/time'
import TempFollowupPlanService from '@/request/template/FollowupPlan'
export default {
  name: 'TempFollowupPlanList',
  components: {},
  props: {
    fid: Number
  },
  data () {
    return {
      listLoading: false,
      list: []
    }
  },
  computed: {},
  created () {
    this.listPlan()
  },
  watch: {},
  methods: {
    listPlan () {
      if (!this.fid) {
        this.list = []
        return
      }
      this.listLoading = true
      TempFollowupPlanService.list({
        fid: this.fid
      }).then(res => {
        this.list = _.clone(res.result || [])
      }).finally(() => {
        this.listLoading = false
      })
    },
    formatterIndex (index) {
      return '第' + (index + 1) + '次随访'
    },
    formatterDuration (row) {
      if (!row || !row.duration) {
        return ''
      }
      let duration = TimeUtils.timeToDuration(0, row.duration)
      let _duration = moment(duration).startOf('day')
      let time = duration - _duration.valueOf()
      let zero = moment(0).startOf('day')
      let years = _duration.clone().diff(zero, 'years', true)
      let months = _duration.clone().diff(zero, 'months', true)
      let weeks = _duration.clone().diff(zero, 'weeks', true)
      let days = _duration.clone().diff(zero, 'days', true)
      let mills = _duration.clone().diff(zero)
      let count = 0
      let benchmark = '日后'
      if (_.isInteger(years)) {
        count = years
        benchmark = '年后'
      } else if (_.isInteger(months)) {
        count = months
        benchmark = '月后'
      } else if (_.isInteger(weeks)) {
        count = weeks
        benchmark = '周后'
      } else if (_.isInteger(days)) {
        count = days
        benchmark = '日后'
      } else {
        count = 0
        benchmark = '日后'
        time += mills
      }
      time += 8 * 60 * 60 * 1000
      return count + benchmark + moment(time).format('HH:mm:ss')
    }
  }
}
</script>

<template>
  <el-table
    :data="list"
    v-loading="listLoading"
    border
    stripe>
    <el-table-column type="index" label="次序" :index="formatterIndex" width="120"></el-table-column>
    <el-table-column prop="duration" label="时间间隔" :formatter="formatterDuration" width="160"></el-table-column>
    <el-table-column prop="label" label="标签" width="120"></el-table-column>
    <el-table-column prop="inquiry" label="内容"></el-table-column>
  </el-table>
  <!-- <div class="plan-list">
    <temp-followup-plan :data="item" v-for="item in list" :key="item.id"></temp-followup-plan>
  </div> -->
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
